<template>
    <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Feature :title="$t('MATERIAL_BASIC_INFORMATION')" :iconClass="'fa-pencil-square-o'">
            <FormRow :fieldNameArr="[$t('FORM_NO'), $t('RFQ_TYPE'), $t('VENDOR_CODE'), $t('PLANT_CODE'), $t('VENDOR_PN')]">
                <Input v-model="quotation.formNo" slot="a" disabled />
                <Input v-model="rfqType" slot="b" disabled />
                <Input v-model="quotation.vendorCode" slot="c" disabled />
                <Input v-model="quotation.plant" slot="d" disabled />
                <Input style="width: 200px" v-model="quotation.vendorPart" slot="e" disabled />
            </FormRow>
            <FormRow :fieldNameArr="[$t('CURRENCY'), $t('DELTA_PN'), $t('DESCRIPTION')]">
                <Input v-model="quotation.currency" slot="a" disabled />
                <Input v-model="quotation.deltaPart" slot="b" disabled />
                <Input style="width: 600px" v-model="quotation.deltaPartDesc" type="textarea" slot="c" disabled :rows="1" />
            </FormRow>
            <FormRow v-if="quotationDocumentView" :fieldNameArr="[$t('PART_SPECIFICATION')]">
            </FormRow>
            <PLMDocument v-if="quotationDocumentView" :plmQuotationDocuments="plmQuotationDocuments"
                :quotationUuid="quotation.uuid"></PLMDocument>
            <FormRow :fieldNameArr="[$t('CATEGORY')]">
                <Input value="Plastic Case" slot="a" disabled />
            </FormRow>
        </Feature>

        <Feature :title="$t('BUYER')" :iconClass="'fa-pencil-square-o'">
            <FormRow v-show="quotation.comments != ''"
                :fieldNameArr="[$t('DELTA_BUYER_NAME'), $t('TARGET_PRICE'), $t('EMAIL'), $t('COMMENTS')]">
                <Input v-model="cpcAccountName" slot="a" disabled />
                <Input v-model="quotation.targetPrice" slot="b" disabled />
                <Input style="width: 800px" v-model="quotation.cpcAccountConstactEmail" type="textarea" slot="c" disabled
                    :rows="1" />
                <Button icon="ios-create" slot="d" @click="openComments">{{ $t('COMMENTS') }}</Button>
            </FormRow>

            <FormRow v-show="quotation.comments == ''"
                :fieldNameArr="[$t('DELTA_BUYER_NAME'), $t('TARGET_PRICE'), $t('EMAIL')]">
                <Input v-model="cpcAccountName" slot="a" disabled />
                <Input v-model="quotation.targetPrice" slot="b" disabled />
                <Input style="width: 800px" v-model="quotation.cpcAccountConstactEmail" type="textarea" slot="c" disabled
                    :rows="1" />
            </FormRow>

            <FormRow v-if="cpcToSupplierReferenceFilesExited" :fieldNameArr="[$t('REFERENCE_FILE')]">
            </FormRow>
            <FormRow v-if="cpcToSupplierReferenceFilesExited" :fieldNameArr="[$t('')]">
                <Table width="600" border :columns="fileSchemaList" :data="cpcToSupplierReferenceFiles" slot="a">
                    <template slot-scope="{ row }" slot="action">
                        <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
                    </template>
                </Table>
            </FormRow>
        </Feature>

        <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
            <PlasticAttributes :plasticQuotation="plasticQuotation" :referencePrice="referencePrice" :priceList="priceList">
            </PlasticAttributes>

            <FormRow :fieldNameArr="['*' + $t('YOUR_PRICE'), '/1 ' + quotation.unit]">
                <Input v-model="quotation.price" :disabled="true" ref="yourPrice" slot="a"
                    style="border-color:red;border-width:1px;border-style:solid;" />
            </FormRow>
            <FormRow v-if="supplierAttachmentExited" :fieldNameArr="['']">
                <Table width="600" border :columns="fileSchemaList" :data="showSupplierQuotationFiles" slot="a">
                    <template slot-scope="{ row }" slot="action">
                        <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
                        <Button v-if="quotation.editable" type="error" shape="circle" icon="md-close-circle"
                            @click="deleteDocument(row)"></Button>
                    </template>
                </Table>
            </FormRow>
            <FormRow :fieldNameArr="[$t('SUPPLIER_REMARK')]">
                <Input style="width: 800px" :maxlength="500" type="textarea" :rows="3"
                    v-model="plasticQuotation.supplierRemark" slot="a"></Input>
            </FormRow>
        </Feature>
        <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModal"
            :title="$t('COMMENTS')">
            <froala :config="FloraEditorConfig" v-model="quotation.comments"></froala>
        </Modal>
    </div>
</template>
   
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { FloraEditorConfig } from "../../util/common"
import { FileSchemaList } from "@/util/tableTitle"
import PLMDocument from '../../components/PLMDocument.vue'
import PlasticAttributes from "@/views/quotation/PlasticAttributes"

export default {
    name: "HistoryOtherCompoment",
    components: {
        PLMDocument,
        PlasticAttributes
    },
    props: {
        quotation: {
            type: Object,
            default: () => null,
        },
        plasticQuotation: {
            type: Object,
            default: () => null,
        },
        priceList: {
            type: Array,
            default: () => [],
        },
        rfqType: {
            type: String,
            default: () => "",
        },
        plmQuotationDocuments: {
            type: Array,
            default: () => [],
        },
        cpcToSupplierReferenceFiles: {
            type: Array,
            default: () => [],
        },
        showSupplierQuotationFiles: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            FloraEditorConfig: FloraEditorConfig(""),
            fileSchemaList: FileSchemaList(this),
            commentsModal: false
        }
    },
    methods: {
        ...mapGetters(["getModalSize"]),
        ...mapActions(["toggleLoading"]),
        downloadAttachment(row) {
            this.$downloadAttachment(this, row.uuid)
        },
        openComments() {
            this.commentsModal = true
        },
    },
    computed: {
        modalSize() {
            return this.getModalSize()
        },
        quotationDocumentView() {
            return this.plmQuotationDocuments && this.plmQuotationDocuments.length > 0
        },
        cpcAccountName() {
            return this.quotation.cpcAccount ? this.quotation.cpcAccount.name : ""
        },
        cpcToSupplierReferenceFilesExited() {
            return this.cpcToSupplierReferenceFiles && this.cpcToSupplierReferenceFiles.length > 0
        },
        supplierAttachmentExited() {
            return this.showSupplierQuotationFiles && this.showSupplierQuotationFiles.length > 0
        },
        referencePrice() {
            let referencePrice = 0
            if (this.plasticQuotation.referencePrices) {
                this.plasticQuotation.referencePrices.forEach(price => {
                    return referencePrice = referencePrice + price.price + "/" + price.currency + "\n"
                })
            } else {
                return null
            }
        }
    },
}
</script>
 
<style scoped></style>
   